import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "optionsSection",
    "optionsContainer",
    "optionInput",
    "optionsField"
  ]
  
  static values = {
    optionTemplate: String
  }
  
  toggleOptionsSection(event) {
    const selectedType = event.target.value
    
    if (selectedType === 'single_select' || selectedType === 'multi_select') {
      this.optionsSectionTarget.style.display = 'block'
    } else {
      this.optionsSectionTarget.style.display = 'none'
      this.clearOptions()
    }
  }
  
  clearOptions() {
    this.optionInputTargets.forEach(input => input.value = '')
    
    const inputs = this.optionInputTargets
    if (inputs.length > 2) {
      inputs.slice(2).forEach(input => input.remove())
    }
  }
  
  addOption(event) {
    event.preventDefault()
    
    const currentOptions = this.optionInputTargets.length
    const nextLetter = String.fromCharCode(65 + currentOptions) // A=65 in ASCII
    
    const template = this.optionTemplateValue.replace(/\{\{letter\}\}/g, nextLetter)
    
    this.optionsContainerTarget.insertAdjacentHTML('beforeend', template)
  }
}
